import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TabsComponent } from './tabs/tabs.component';
import { CurrentComponent } from './current/current.component';
import { EnhancedComponent } from './enhanced/enhanced.component';
import { ComparisonComponent } from './comparison/comparison.component';
import { HttpClientModule } from '@angular/common/http';
import { PercentageDirective } from './percentage.directive';
import { NumberDirective } from './number.directive';
import {ToastrModule} from 'ngx-toastr';
import { OptimizeComponent } from './optimize/optimize.component';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [
    AppComponent,
    TabsComponent,
    CurrentComponent,
    EnhancedComponent,
    ComparisonComponent,
    PercentageDirective,
    NumberDirective,
    OptimizeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({
      positionClass :'toast-top-center',
      timeOut:3000,
      preventDuplicates:true
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
